export default [
  "created",
  "modified-date",
  "confirmation_datetime",
  "dangerous_goods",
  "total_weight_kg",
  "total_weight_lbs",
  "total_volume_cbm",
  "pickup_date",
  "stop1_date",
  "export_clearance",
  "transit_clearance",
  "import_clearance",
  "service_requirement",
  "incoterms",
  "insurance",
  "custom_field_01",
  "custom_field_02",
  "reason_code",
  "cost_center",
  "related_shipments_count",
] as const;
